module.exports = __webpack_public_path__ + "img/624541_FCD0C6_E4A19A_FCBCB4-256px.d3f443b7.png";